import { eventRoutes } from "@circle-react/lib/routes/events";

interface SpaceEventProps {
  spaceSlug: string;
}

interface EventProps extends SpaceEventProps {
  eventSlug: string;
}

export const newSpaceEventPath = ({ spaceSlug }: SpaceEventProps) =>
  `/c/${spaceSlug}/events/new`;
export const eventsShowPath = ({ spaceSlug, eventSlug }: EventProps) =>
  eventRoutes.detail({ path: { spaceSlug, eventSlug } });
